


































































































import { Vue, Component } from 'vue-property-decorator';

import buttonGreen from '@/components/atomic/atoms/ButtonGreen.vue';

import businessAnimation from '@/assets/animations/business.svg';
import businessImage from '@/assets/images/business.svg';
import businessImage1 from '@/assets/images/business_1.svg';
import businessImage2 from '@/assets/images/business_2.svg';
import businessImage3 from '@/assets/images/business_3.svg';

@Component({
  name: 'BusinessSection',
  components: {
    buttonGreen,
  },
})
/**
 * @vuese
 * @group Page/BusinessSection
 * BusinessSection component
 */
export default class BusinessSection extends Vue {
  // [data]
  showAnimation: boolean = true;
  businessAnimation: string = '';
  businessImage: string = businessImage;
  businessImage1: string = businessImage1;
  businessImage2: string = businessImage2;
  businessImage3: string = businessImage3;

  // [method]
  contact() {}

  xidBusinessAnimation(event: Event, el: any) {
    if (this.businessAnimation === '') {
      const rect = el.getBoundingClientRect();
      const inView = (
        rect.width > 0 && rect.height > 0 && rect.top >= -200
        && rect.bottom - 200 <= (window.innerHeight || document.documentElement.clientHeight)
      );
      if (inView) this.businessAnimation = businessAnimation;
    }
  }

  // [lifecycle]
  created() {
    if (window.innerWidth <= 960) this.showAnimation = false;
  }
}

// [directive]
Vue.directive('scroll', {
  inserted: (el, binding) => {
    const f = (evt: any) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});
